import { jsx, jsxs } from 'react/jsx-runtime';
import { useContext } from 'react';
import '../../layout-flex/types/index.esm.js';
import { EGDSLayoutFlex } from '../../layout-flex/layout-flex/index.esm.js';
import { EGDSLayoutFlexItem } from '../../layout-flex/layout-flex-item/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSRadioButtonGroupContext } from '../radio-button-group-provider/index.esm.js';
import styles from '../../styles/uitk-egds-radio-button.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { useEGDSContext } from '../../utils/context-provider/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSRadioButton = props => {
  let useReducedMotion = false;
  if (typeof window !== 'undefined') {
    useReducedMotion = window.matchMedia(`(prefers-reduced-motion: reduce)`).matches;
  }
  const {
    className,
    children,
    checked,
    description,
    disabled,
    id,
    label,
    labelClassName,
    labelSuffix,
    required,
    name,
    value,
    a11yLabel,
    onChange
  } = props;
  const RadioButtonGroupContext = useContext(EGDSRadioButtonGroupContext);
  const baseCssClass = 'uitk-radio-button';
  const CssClassNameLabelSuffix = labelSuffix ? `${baseCssClass}-label-haslabelsuffix` : null;
  const wrapperClassNames = getClassNameList(baseCssClass, {
    'is-disabled': disabled
  });
  const labelCssClassNames = getClassNameList(`uitk-radio-button-label`, CssClassNameLabelSuffix, {
    [labelClassName]: Boolean(labelClassName),
    'is-required': required
  });
  const inputClassNames = getClassNameList({
    checked
  }, className);
  const contents = label || children;
  const checkedProp = RadioButtonGroupContext?.defaultChecked ? 'defaultChecked' : 'checked';
  const isChecked = checked || RadioButtonGroupContext?.selected === value;
  const controlClassNames = getClassNameList(`${baseCssClass}-control`);
  const reducedMotionClassNames = getClassNameList(`${baseCssClass}-has-reduced-motion`);
  const {
    data: contextData
  } = useEGDSContext();
  const {
    hasRequiredFieldIndicator
  } = contextData ?? {};
  const randomId = Math.random().toString(36).substring(7);
  const uniqueDescriptionId = `radio-button-description-${randomId}`;
  const a11yContent = a11yLabel ?? contents?.toString();
  const a11yFullLabel = labelSuffix ? `${a11yContent} ${labelSuffix}` : a11yContent;
  return jsx(EGDSLayoutFlex, {
    className: wrapperClassNames,
    wrap: "nowrap",
    children: jsx(EGDSLayoutFlexItem, {
      className: getClassNameList(`${baseCssClass}-content`),
      grow: 1,
      children: jsx("div", {
        children: jsxs("label", {
          className: labelCssClassNames,
          htmlFor: id,
          children: [jsx("input", {
            type: "radio",
            name: name || RadioButtonGroupContext?.group,
            id: id,
            [checkedProp]: isChecked,
            className: inputClassNames,
            onChange: onChange || RadioButtonGroupContext?.onChange,
            value: value,
            disabled: disabled,
            "aria-label": a11yFullLabel,
            "aria-describedby": description ? uniqueDescriptionId : ''
          }), jsx("span", {
            "aria-hidden": "true",
            className: useReducedMotion ? `${controlClassNames} ${reducedMotionClassNames}` : controlClassNames
          }), jsxs("span", {
            "aria-hidden": Boolean(a11yLabel),
            className: getClassNameList(`${baseCssClass}-label-content`),
            children: [contents, required && hasRequiredFieldIndicator && jsxs("span", {
              className: getClassNameList('uitk-radio-button-required-asterisk'),
              "aria-hidden": "true",
              children: [' ', "*"]
            })]
          }), labelSuffix && jsx("span", {
            "aria-hidden": Boolean(a11yLabel),
            className: getClassNameList(`${baseCssClass}-label-suffix`),
            children: labelSuffix
          }), a11yLabel && jsx("span", {
            className: "is-visually-hidden",
            children: a11yLabel
          }), description && jsx("span", {
            className: getClassNameList(`${baseCssClass}-description uitk-type-200`),
            id: uniqueDescriptionId,
            children: description
          })]
        })
      })
    })
  });
};
export { EGDSRadioButton };